const creditCardData = [
    {
        id: 1,
        creditCardNumber: '**** **** **** 5412',
        type: 'MASTERCARD'
    },
    {
        id: 2,
        creditCardNumber: '**** **** **** 9124',
        type: 'VISACARD'
    }, 
];

export default creditCardData;